import React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import Layout from './src/components/Layout';
import { Provider } from './src/components/ui/provider';

// export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
//   element,
// }) => {
//   return <Provider>{element}</Provider>;
// };

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
}) => {
  return (
    <React.StrictMode>
      <Provider>
        <Layout>{element}</Layout>
      </Provider>
    </React.StrictMode>
  );
};

// export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {

// }

// | API               | Purpose                         |
// | ----------------- | ------------------------------- |
// | `wrapRootElement` | Providers (global state, theme) |
// | `wrapPageElement` | UI layout (Navbar, Footer)      |
